export default [
    {
        path: 'exportacao',
        component: () => import(/* webpackChunkName: 'bpa-exportacao' */ '@/views/bpa/exportacao/Index'),
        redirect: 'exportacao/index',
        children: [
            {
                name: 'bpa-exportacao-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'bpa-exportacao-index' */'@/views/bpa/exportacao/List.vue'),
            },
        ],
    },
]